import { Icon } from "@iconify/react/dist/iconify.js";

export default function FilterToggle({ isOpen, placeholder, onClick }) {
  return (
    <button
      className={`hitq-panel-toggle ${isOpen ? "active" : ""}`}
      type="button"
      onClick={onClick}
    >
      <span className="hitq-panel-toggle-text">{placeholder}</span>
      {isOpen ? (
        <Icon
          icon="iconamoon:arrow-down-2-duotone"
          color="rgb(204, 204, 204)"
          width="24"
          height="24"
          transform="rotate(180)"
        />
      ) : (
        <Icon
          icon="iconamoon:arrow-down-2-duotone"
          color="rgb(204, 204, 204)"
          width="24"
          height="24"
        />
      )}
    </button>
  );
}
